export const FIELDS = {
  TITLE: 'title',
  URL: 'url',
  IS_ACTIVE: 'is_active',
};
